import { render } from "./StyleGuideComponent.vue?vue&type=template&id=6a5ffc72&scoped=true"
import script from "./StyleGuideComponent.vue?vue&type=script&lang=js"
export * from "./StyleGuideComponent.vue?vue&type=script&lang=js"

import "./StyleGuideComponent.vue?vue&type=style&index=0&id=6a5ffc72&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5ffc72"]])

export default __exports__